import { render, staticRenderFns } from "./BildmitText.vue?vue&type=template&id=593c1d44"
import script from "./BildmitText.vue?vue&type=script&lang=js"
export * from "./BildmitText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports